export default __webpack_public_path__ + "static/media/subjektet_zgjedhore_1.bab9418e.jpg";